export default __webpack_public_path__ + "fbe005e845886f4619bb1ca93c0bc57a.png";